import React, {useCallback, useEffect, useState} from "react";
import {Redirect} from "react-router-dom";
import {connect, useDispatch, useSelector} from "react-redux";
import {
    ENTERZIP,
    FINDTIRES,
    FRONTPAGENAME,
    MAKE,
    MAKEERROR,
    MODEL,
    MODELERROR,
    required,
    SIZEERROR,
    SPECIFICTIRES,
    TIRESIZE,
    TRIM,
    TRIMERROR,
    YEAR,
    YEARERROR,
    ZIP_ERROR
} from "../../shared/constantsEN";
import FormControl from "@material-ui/core/FormControl";
import HelpModal from "./helpModal";
import {Divider, FormHelperText, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import yearMakeModelService from "../../shared/services/yearMakeModelService";
import searchResultsService from "../../shared/services/searchResultsService";
import {
    clearCurrentLatLng,
    selectDealer,
    setBAC,
    setDealers,
    setFilteredResult,
    setMakes,
    setModels,
    setSearchResult,
    setSelectMake,
    setSelectModel,
    setSelectSize,
    setSelectTrim,
    setSelectYear,
    setSizes,
    setTrims,
    setZipCode,
    toggleOffFirstLoad,
    updateResults
} from "../../core/redux/ActionCreator";
import UseCurrentLocationButton from "../component/useCurrentLocationButton";
import Offer from "../component/Offers/offer";
import Analytics from "../../shared/util/analytics";
import dealerLocatorService from "../../shared/services/dealerLocatorService";
import store from "../../core/redux/Store";

function SearchByVehicleInfo ({bac, makes, models,trims, sizes, years}) {
    const clearData = [];
    const dispatch = useDispatch();
    const[errMake, setErrMake] = useState(false);
    const[errModel, setErrModel] = useState(false);
    const[errSize, setErrSize] = useState(false);
    const[errTrim, setErrTrim] = useState(false);
    const[errYear, setErrYear] = useState(false);
    const[errZip, setErrZip] = useState(false);
    const[isValid, setIsValid] = useState(false);
    const[hasBAC, setHasBAC] = useState(false);
    const[make, setMake] = useState('');
    const[makeError, setMakeError] = useState(false);
    const[model, setModel] = useState('');
    const[modelError, setModelError] = useState(false);
    const[size, setSize] = useState('');
    const[sizeError, setSizeError] = useState(false);
    const[trim, setTrim] = useState('');
    const[trimError] = useState(false);
    const[year, setYear] = useState('');
    const[yearError, setYearError] = useState(false);
    const[zip, setZip] = useState('');
    const[zipError, setZipError] = useState(false);
    const resultsUpdated = useSelector(state => state.searchResultReducer.updateResult);
    const queryParams = new URLSearchParams(window.location.search);
    const queryMake = queryParams.get('make');
    const queryModel = queryParams.get('model');
    const queryYear = queryParams.get('year');
    const querySize = queryParams.get('size');
    const queryZip = queryParams.get('zip');
    const isDealerSite = useSelector(state => state.dealerReducer.isDealerSite);
    const reduxZipCode = useSelector(state => state.yearMakeModelReducer.zipCode);
    const firstLoadFlag = useSelector(state => state.appParamsReducer.firstLoadFlag);
    const analytics = Analytics();
    const localStore = store.getState()

    const queryFetch = useCallback(() => {
        if (bac !== 999999) {
            setHasBAC(true);
            dispatch(setSearchResult([]));
            console.log(querySize);
            searchResultsService.getResults(querySize, queryYear, queryMake, queryModel, bac);
            dispatch(updateResults({updateResult: true}));
        } else {
            setIsValid(true);
        }
    }, [bac, dispatch, querySize, queryYear, queryMake, queryModel]);

    useEffect(() => {
        analytics.trackPage('find-tires');

        if (!firstLoadFlag) {
            // eslint-disable-next-line no-undef
            _satellite.track('find-tires');
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (resultsUpdated) {
            dispatch(setSearchResult([]));
            dispatch(updateResults({updateResult: false}));
            dispatch(setFilteredResult([]));
        }
    }, [resultsUpdated, dispatch]);

    useEffect(() => {
        if (queryMake !== null && queryModel !== null && queryYear !== null
            && querySize !== null && queryZip !== null) {
            dispatch(setSelectMake(queryMake));
            dispatch(setSelectModel(queryModel));
            dispatch(setSelectSize(querySize));
            dispatch(setSelectYear(queryYear));
            dispatch(setZipCode(queryZip));

            queryFetch();
        }
    }, [querySize, queryYear, queryMake, queryModel, queryZip,queryFetch, dispatch]);

    useEffect(function getYears() {
        if (years.length === 0) yearMakeModelService.getYears();
        if (year !== '' && makes.length === 0) yearMakeModelService.getMakes(year);
        if (year !== '' && make !== '' && models.length === 0) yearMakeModelService.getModels(year, make);
        if (year !== '' && make !== '' && model !== '' && trims.length === 0) {
            yearMakeModelService.getTrims(year, make, model);
            yearMakeModelService.getSizes(year, make, model, null);
        }
        if (year !== '' && make !== '' && model !== '' && sizes.length === 0) {
            yearMakeModelService.getSizes(year, make, model, trim);
        }
    });

    useEffect(()=>{
        if(sizes.length ===1 && size === '' && model !== ''){
            setSize(sizes[0]);
            dispatch(setSelectSize(sizes[0]));
            setErrSize(false);
            setSizeError(false);
        }
        // eslint-disable-next-line
    },[sizes])

    if (isValid) return <Redirect to="/dealerLocator"/>;

    if (hasBAC) return <Redirect to="/searchResult"/>;

    function validateAndLoad(path) {
        dispatch(updateResults({updateResult:true}));
        if (year !== '' && make !== '' && model !== '' && size !== ''
            && (!isDealerSite && path === 'zip' ? zip.match(/^\b\d{5}(-\d{4})?\b$/) : true)) {
            dispatch(toggleOffFirstLoad());
            if (isDealerSite) {
                setHasBAC(true);
                if (localStore.dealerReducer.bac !== 999999) {
                    dealerLocatorService.getDealerByBAC(localStore.dealerReducer.bac)
                }
                dispatch(setSearchResult([]));
                searchResultsService.getResults(size, year, make, model, bac);
                dispatch(updateResults({updateResult: true}));
            } else {
                if (path !== 'zip') {
                    dispatch(setZipCode('empty'));
                } else if (reduxZipCode !== zip) {
                    dispatch(selectDealer({dealerBAC:''}));
                    dispatch(setDealers([]));
                }
                setIsValid(true);
            }
        } else {
            if (year === '') setYearError(true);
            if (make === '') setMakeError(true);
            if (model === '') setModelError(true);
            if (size === '') setSizeError(true);
            if (zip === '' && path === 'zip') setZipError(true);
        }
    }

    // inputProps class had to hardcode the materialUI class with the Adobe Launch Analytics class
    // couldn't find a way to get the materialUI class programmatically
    const yearDropdown = (
        <FormControl variant="outlined">
            <InputLabel className="dropdownLabel" htmlFor="year-dropdown-label">
                {YEAR}
            </InputLabel>
            <Select
                error={yearError}
                id="year-dropdown-label"
                label={YEAR}
                value={year}
                onChange={handleChangeYear}
                onClose={handleCloseYear}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {years.map(item => (<MenuItem  key={item} value={item}>{item}</MenuItem>))}
            </Select>
            {errYear && (<FormHelperText error>{YEARERROR}</FormHelperText>)}
            {yearError && (<FormHelperText error>{required}</FormHelperText>)}
        </FormControl>
    );

    const makeDropdown = (
        <FormControl variant="outlined">
            <InputLabel
                className="make-dropdown-label"
                disabled={!year}
                htmlFor="make-dropdown-label"
            >
                {MAKE}
            </InputLabel>
            <Select
                className="make-dropdown stat-dropdown"
                data-dtm="vehicle info"
                error={makeError}
                labelId="make-dropdown-label"
                onChange={handleChangeMake}
                onClose={handleCloseMake}
                label={MAKE}
                value={make}
                disabled={!year}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {makes.map(item => (
                    <MenuItem className="dropdown-group-element" key={item} value={item}>
                        {item}
                    </MenuItem>))}
            </Select>
            {errMake && (<FormHelperText error>{MAKEERROR}</FormHelperText>)}
            {makeError && (<FormHelperText error>{required}</FormHelperText>)}
        </FormControl>
    );

    const modelDropdown = (
        <FormControl variant="outlined">
            <InputLabel
                className="model-dropdown-label"
                disabled={!make}
                htmlFor="model-dropdown-label"
            >
                {MODEL}
            </InputLabel>
            <Select
                className="model-dropdown stat-dropdown"
                data-dtm="vehicle info"
                error={modelError}
                label={MODEL}
                labelId="model-dropdown-label"
                onChange={handleChangeModel}
                onClose={handleCloseModel}
                value={model}
                disabled={!make}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {models.map(item => (
                    <MenuItem className="dropdown-group-element" key={item} value={item}>
                        {item}
                    </MenuItem>))}
            </Select>
            {errModel && (
                <FormHelperText error>{MODELERROR}</FormHelperText>
            )}
            {modelError && (
                <FormHelperText error>{required}</FormHelperText>
            )}
        </FormControl>
    );

    const trimDropdown = (
        <FormControl variant="outlined">
            <InputLabel
                className="trim-dropdown-label"
                disabled={!model}
                htmlFor="model-dropdown-label"
            >
                {TRIM}
            </InputLabel>
            <Select
                className="trim-dropdown stat-dropdown"
                data-dtm="vehicle info"
                error={trimError}
                label={TRIM}
                labelId="model-dropdown-label"
                onChange={handleChangeTrim}
                value={trim}
                disabled={!model}
                inputProps={{
                    "class": `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {trims.map((item) => (
                    <MenuItem key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
            {errTrim && (<FormHelperText error>{TRIMERROR}</FormHelperText>)}
        </FormControl>
    );

    const sizeDropdown = (
        <FormControl variant="outlined">
            <InputLabel
                className="trim-dropdown-label"
                disabled={!model}
                htmlFor="model-dropdown-label"
            >
                {TIRESIZE}
            </InputLabel>
            <Select
                className="trim-dropdown stat-dropdown"
                data-dtm="vehicle info"
                error={sizeError}
                labelId="size-dropdown-label"
                label={TIRESIZE}
                onChange={handleChangeSize}
                onClose={handleCloseSize}
                value={size}
                disabled={!model}
                inputProps={{
                    class: `MuiSelect-nativeInput stat-dropdown`,
                    "data-dtm": "vehicle info"
                }}
                required
            >
                {sizes.map((item) => (
                    <MenuItem key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
            {errSize && (
                <FormHelperText error>{SIZEERROR}</FormHelperText>
            )}
            {sizeError && (
                <FormHelperText error>{required}</FormHelperText>
            )}
        </FormControl>
    );

    function handleChangeMake (event) {
        dispatch(setSelectMake(event.target.value));
        setMake(event.target.value);
        setModel('');
        setTrim('');
        setSize('');
        setModelError(false);

        dispatch(setModels(clearData));
        dispatch(setTrims(clearData));
        dispatch(setSizes(clearData));
    }

    function handleCloseMake (event) {
        if (event.target.value === undefined && make === '') {
            setErrMake(true);
            setMakeError(false);
        } else {
            setErrMake(false);
            setMakeError(false);
        }
    }

    function handleChangeModel (event){
        setModel(event.target.value);
        dispatch(setSelectModel(event.target.value));

        if (model !== '' && model !== event.target.value) {
            dispatch(setTrims(clearData));
            dispatch(setSizes(clearData));
        }

        setErrSize(false);
        setErrTrim(false);
        setTrim('');
        setSize('');
    }

    function handleCloseModel (event){
        if (event.target.value === undefined && model === '') {
            setErrModel(true);
            setModelError(false);
        } else {
            setModelError(false);
            setErrModel(false);
        }
    }

    function handleChangeSize (event){
        setSize(event.target.value);
        dispatch(setSelectSize(event.target.value));
        if(trim === '')dispatch(setSelectTrim(null));
    }

    function handleCloseSize (event){
        if (event.target.value === undefined && size==='') {
            setErrSize(true);
            setSizeError( false);
        } else {
            setErrSize(false);
            setSizeError( false);
        }
    }

    function handleChangeTrim (event) {
        dispatch(setSelectTrim(event.target.value));
        setTrim(event.target.value);
        setSize('');
        setErrSize(false);
        dispatch(setSizes(clearData));
    }

    function handleChangeYear(event) {
        setYear(event.target.value);
        dispatch(setSelectYear(event.target.value));
        setMakeError(false);
        setMake('');
        setModel('');
        setTrim('');
        setSize('');

        dispatch(setMakes(clearData));
        dispatch(setModels(clearData));
        dispatch(setTrims(clearData));
        dispatch(setSizes(clearData));

    }

    function handleCloseYear (event) {
        if (event.target.value === undefined && year === '') {
            setErrYear(true);
            setYearError(false);
        } else {
            setErrYear(false);
            setYearError(false);
        }
    }

    function zipCodeValidation (event){
        if (!event.currentTarget.value.match(/^\b\d{5}(-\d{4})?\b$/)){
            setErrZip(true);
            setZipError(false);
        } else{
            setErrZip(false);
            setZipError(false);
        }
    }

    function updateSelectedZipCode(event) {
        setZip(event.target.value);
        if (event.currentTarget.value.match(/^\b\d{5}(-\d{4})?\b$/)) {
            dispatch(clearCurrentLatLng());
            dispatch(setZipCode(event.target.value));
            setErrZip(false);
            setZipError(false);
        }
    }

    const zipcodeSection = (
        <div className={'spacer'} >
            <div className="miniHeader">
                <label className="zipHeader">{ENTERZIP}</label>
                <TextField id="inputZipCode" name="zipCodeInput" variant="outlined"
                           className="tpcTextBox stat-search-input" data-dtm="vehicle info"
                           InputProps = {{inputProps: {maxLength: 5}}}
                           oninput="this.value=this.value.slice(0,this.maxLength)"
                           value={zip} onChange={updateSelectedZipCode} onBlur={zipCodeValidation}/>
                {errZip && (<FormHelperText error>{ZIP_ERROR}</FormHelperText>)}
                {zipError && (<FormHelperText error>{required}</FormHelperText>)}
            </div>
            <UseCurrentLocationButton dataDtm="vehicle info" handleClick={() => validateAndLoad('geolocation')}/>
        </div>
    );

    return <>
            <Offer/>
            <div className="Chevy-find-new-tires-xl">
                <div className="yearMakeModelDisplay">
                    <div className="header">{FRONTPAGENAME}</div>
                    <div className="miniHeader">{SPECIFICTIRES}</div>
                    <br/>
                    <div className="miniHeader">
                            <div className={'spacer'}>{yearDropdown}</div>
                    </div>
                    <div className="miniHeader">
                            <div className={'spacer'}>{makeDropdown}</div>
                    </div>
                    <div className="miniHeader">
                            <div className={'spacer'}>{modelDropdown}</div>
                    </div>
                    <div className="miniHeader">
                            <div className={'spacer'}>{trimDropdown}</div>
                    </div>
                    <div className="miniHeader">
                            <div>{sizeDropdown}</div>
                    </div>
                    <div className="miniHeader">
                        <HelpModal/>
                        <div className={'spacer'}/>
                    </div>
                    <Divider className={'header'}/>
                    <div className={'spacer'}/>
                    {!isDealerSite && (zipcodeSection)}
                    <button className="button primary-button stat-button-link" data-dtm="vehicle info"
                            onClick={() => validateAndLoad('zip')}>{FINDTIRES}</button>

            </div>
        </div>
    </>
}

const mapStateToProps = (state) => {
    return {
        bac: state.dealerReducer.bac,
        years: state.yearMakeModelReducer.years,
        makes: state.yearMakeModelReducer.makes,
        models: state.yearMakeModelReducer.models,
        trims: state.yearMakeModelReducer.trims,
        sizes: state.yearMakeModelReducer.sizes,
        zipCode: state.yearMakeModelReducer.zipCode,
    }
};

export default connect(mapStateToProps, {setSelectYear, setSelectMake, setSelectModel,
    setSelectTrim, setSelectSize, setZipCode, setBAC})(SearchByVehicleInfo)
